import styled from 'styled-components'

import { movimiento } from '../../styles/animations'

import { 
  pinkAuricula,
  blackAuricula,
  whiteAuricula,
  

} from '../../styles/colorStyles'

export const ModalHamburguer = styled.div `
  display: none;

  @media (min-width:600px) and (max-width: 1024px) {
  
  }

  @media (max-width: 600px) {
  display: ${props => props.showModalHamburguer ? 'inline-block': 'none'};
  width: 100%;
  height: 100vh;
  background-color: black;
  position:absolute;
  top: 0;
  left: 0;
  background-color: black;
  z-index: 1000;
  animation: ${movimiento} .75s linear;
    
  > div {
    display: flex;
    flex-direction: column;
    height: 100%;

    > div:nth-child(1) {
      margin-top: 12%;
      margin-left: 80%;
      width: 23px;
      height: 2px;
      position: relative;
      border-radius: 2px;

      > div:before,
        div:after {
        content: '';
        position: absolute;
        width: 30px;
        height: 2px;
        background-color:${pinkAuricula};
        border-radius: 10px;
      }

      > div:before {
        -webkit-transform: rotate(45deg);
        -moz-transform: rotate(45deg);
        transform: rotate(45deg);
        left: -9px;
      } 
      
      > div:after {
        -webkit-transform: rotate(-45deg);
        -moz-transform: rotate(-45deg);
        transform: rotate(-45deg);
        right: 2px;
      }
    }

    > div:nth-child(2) {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top:45%;
      
      > div:nth-child(1),
        div:nth-child(2),
        div:nth-child(3),
        div:nth-child(4) {
        padding-bottom:25%;
        
        > a {
          text-decoration: none;
          font-size: 6vw;
          font-family:'BebasNeue';
          color: ${whiteAuricula}; 
          cursor: pointer; 
          text-transform: uppercase;
          transition: all 0.5s;
          position: relative;

          &:hover {
            color:${pinkAuricula};
            background-size: 100% 2px;  
          }

          &:before {
            content: '';
            width: 0;
            height: 2px;
            background-color: ${pinkAuricula};
            position: absolute;
            top: 120%;
            left: 0;
            transition: all 0.5s;
          }

          &:hover:before {
            width: 50%;
            transform: translateX(100%);
          }

          &:after {
            content: '';
            width: 0;
            height: 2px;
            background-color: ${pinkAuricula};
            position: absolute;
            top: 120%;
            right: 0;
            transition: all 0.5s;
          }

          &:hover:after {
            width: 50%;
            transform: translateX(-100%);
          }
        }
      }
    }
  }
}

`

export const Nav = styled.nav `
  display: flex;
  padding-bottom: 5%;
  background:black;
  
  @media (min-width:600px) and (max-width: 1024px) {
    
  }

  @media (max-width: 600px) {
    padding-bottom: 10%;   
  }
`

export const NavLogo = styled.section `
  margin : 5% 0 0 5%;
  width: 40px;
  height: 130px;

  img {
    width: 100%;
    height: 100%;
  }

  @media (min-width:600px) and (max-width: 1024px) {
    
    img {
y
    }
  }

  @media (max-width: 600px) {
    margin: 10% 0 0 10%;
    
    img {
    }
  }
`

export const NavButton = styled.div `
  display: flex;
  cursor: pointer;
  margin: 5% 0% 0% 65%;

  div {
    padding-right:15%;
    
    > a {
      font-size: 1.5vw;
      font-family: 'BebasNeue';
      color: ${whiteAuricula};
      text-decoration: none;
      text-transform: uppercase;
      transition: all 0.5s;
      position: relative; 
    }

    > a:hover {
      color: ${pinkAuricula};
      background-size: 100% 2px;
    }

    > a:before {
      content: '';
      width: 0;
      height: 2px;
      background-color: ${pinkAuricula};
      position: absolute;
      top: 120%;
      left: 0;
      transition: all 0.5s;
    }

    > a:hover:before {
      width: 50%;
      transform: translateX(100%);
    }

    > a:after {
      content: '';
      width: 0;
      height: 2px;
      background-color: ${pinkAuricula};
      position: absolute;
      top: 120%;
      right: 0;
      transition: all 0.5s;
    }

    > a:hover:after {
      width: 50%;
      transform: translateX(-100%);
    }  
  }

  @media (min-width:600px) and (max-width: 1024px) {
    margin: 5% 0% 0% 58%;

    div{

      > a {
       font-size: 2vw;
      }

      > a:hover {
      }

      > a:before {
      }

      > a:hover:before {
      }

      >  a:after {
      }

      > a:hover:after {
      }
      
    }
  }

  @media (max-width: 600px) {
    display: none;
    margin: 5% 0% 0% 10%;

    div{

      > a {
      }

      > a:hover { 
      }

      > a:before {
      }

      > a:hover:before {
      }

      >  a:after {
      }

      > a:hover:after {
      }  
    }
  }
`

export const MenuHamburguer = styled.div `
  cursor: pointer;
  display: none;
  
  &:hover{
    > div:nth-child(1) {
      background-color:${pinkAuricula}
    }
  }

  &:hover{
    > div:nth-child(2) {
      background-color:${pinkAuricula} ;
      width: 60%;
      transition: all 0.2s linear;
    }
  }

  &:hover{
    > div:nth-child(3) {
      background-color:${pinkAuricula} ;
      width: 20%;
      transition: all 0.2s linear;
    }
  }

  > div:nth-child(1) {
    width: 30px;
    height: 2px;
    margin: 30% 0 5% 0;
    background-color: white;
  }

  > div:nth-child(2) {
    width: 30px;
    height: 2px;
    margin: 30% 0 5% 0;
    background-color: white;
  }

  > div:nth-child(3) {
    width: 30px;
    height: 2px;
    margin: 30% 0 5% 0;
    background-color: white;
  }

  @media (min-width:600px) and (max-width: 1024px) {
    display: none;
  
    &:hover{
      > div:nth-child(1) {
      }
    }

    &:hover{
      > div:nth-child(2) {
      }
    }

    &:hover{
      > div:nth-child(3) {
      }
    }

    > div:nth-child(1) {
     
    }

    > div:nth-child(2) {
     
    }

    > div:nth-child(3) {
      
    }
  }

  @media (max-width: 600px) {
    cursor: pointer;
    display: inline-block;
    
    &:hover{
      > div:nth-child(1) {
        background-color: ${pinkAuricula} ;
      }

      > div:nth-child(2) {
        background-color: ${pinkAuricula} ;
        width: 60%;
        transition: all 0.2s linear;
      }

      > div:nth-child(3) {
        background-color: ${pinkAuricula} ;
        width: 20%;
        transition: all 0.2s linear;
      }
    }

    > div:nth-child(1) {
      width: 25px;
      height: 2px;
      margin: 150% 0 2% 850%;
      background-color:  ${whiteAuricula};
    }

    > div:nth-child(2) {
      width: 25px;
      height: 2px;
      margin: 12% 0 2% 850%;
      background-color:  ${whiteAuricula};
    }

    > div:nth-child(3) {
      width: 25px;
      height: 2px;
      margin: 12% 0 2% 850%;
      background-color:  ${whiteAuricula};
    }
  }
`

export const PageWebInfo = styled.section `
  background-image: url('https://s3.amazonaws.com/atrium1.0/Nuevobanner_web.jpg');
  padding-bottom: 3%;
  background-size: 100% 100%;

  > h2:nth-child(1) {
    padding: 5% 0 0 10%;
    font-size: 4vw;
    font-family:'BebasNeue' ;
    color: ${whiteAuricula};
  }

  > h2:nth-child(2) {
    padding: 0 0 2% 10% ;
    font-size: 4vw;
    font-family:'BebasNeue' ;
    color: ${whiteAuricula};
  }

  > div {
    width: 7%;
    height: 3px;
    margin-left: 10%;
    background-color: ${whiteAuricula};
  }

  > p:nth-child(4) {
    margin:3% 0 0 10%;
    width: 50%;
    font-size: 1.5vw;
    font-family:'NotoSansRegular';
    color: ${whiteAuricula};

    > span {
      font-weight: bold;
    }
  }

  > p:nth-child(5) {
    width: 48%;
    margin: 2% 0 3% 10%;
    font-size: 1.5vw;
    font-family:'NotoSansRegular';
    color: ${whiteAuricula};
    
    > span {
      font-weight: bold;
    }
  }

  @media (min-width:600px) and (max-width: 1024px) {
   
    > h2:nth-child(1) {
      
;
    }

    > h2:nth-child(2) {
      
    }

    > div {
      
    }

    > p:nth-child(4) {
      

      > span {
        
      }
    }

    > p:nth-child(5) {
      
      
      > span {
        
      }
    }

  }

  @media (max-width: 600px) {
    background-image: url('https://s3.amazonaws.com/atrium1.0/Nuevobanner_web_mobile.jpg');
    padding-bottom: 125%;

    > h2:nth-child(1) {
      padding: 12% 0 0 10%;
      font-size: 10vw;
    }

    > h2:nth-child(2) {
      padding: 0 0 8% 10% ;
      font-size: 10vw;
    }

    > div {
      width: 18%;
    }

    > p:nth-child(4) {
      margin:8% 0 0 10%;
      width: 80%;
      font-size:3.5vw;

      > span {
        font-weight: bold;
      }
    }

    > p:nth-child(5) {
      width: 80%;
      margin: 5% 0 3% 10%;
      font-size: 3.5vw;
      
      > span {
        font-weight: bold;
      }
    }   
  }
    
`

export const Video = styled.section `
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 6% 0 6% 0;
  background: black;

  @media (min-width:600px) and (max-width: 1024px) {
    display: none;
  }

  @media (max-width: 600px) {
    display: none;
  }

 `

export const VideoIpad = styled.section `
  display: none;

  @media (min-width:600px) and (max-width: 1024px) {
    display: flex;
    justify-content: center;
    width: 100%;
    padding: 6% 0 6% 0;
    background: black;
  }

  @media (max-width: 600px) {
    display: none;
  }

`

export const VideoMobile = styled.section `
  display: none;

  @media (min-width:600px) and (max-width: 1024px) {
    display: none;

  }

  @media (max-width: 600px) {
    display: inline-block;
    display: flex;
    justify-content: center;
    width: 100%;
    padding: 6% 0 6% 0;
    background: black;
  }

`


export const Quote = styled.section `
  display: flex;
  flex-direction: column;
  align-items: center;
  background:black;
  padding-bottom: 8%;
  

  > div:nth-child(1) {
    width: 7%;
    height: 3px;
    margin: 8% 0 2% 0;
    background-color: ${pinkAuricula};
  } 

  > p {
    padding-bottom: 3%;
    font-size: 2vw;
    font-family:'NotoSansBold';
    color: ${whiteAuricula};
    /* ${props => props.cambiocolor ? 'pink' : whiteAuricula} */
  }

  > div:nth-child(3) {
    display: flex;
    width: 8%;
    background-color: transparent;
    cursor: pointer;
    transition:all linear 1s;
    
    

    &:hover {
      background: ${pinkAuricula};
      transition: all 1s;
    }

    &:hover {

      > div:nth-child(1) > a {
        color: ${blackAuricula};  
        transition: all 1s;
      }

      > div:nth-child(2) {
        border-left: 2.2em solid ${blackAuricula};
        transition: all 1s;
       
      } 
    }

    > div {
      display: flex;
      flex-direction: column;
      
      > a:nth-child(1) {
        width: 90%;
        color: ${whiteAuricula};
        font-size: 3vw;
        font-family:'BebasNeue' ;
        font-weight: bold;
        text-decoration: none;
        letter-spacing: 1px;
        line-height: 85%;
        margin-top: 3%;
        margin-left: 1%;
       
      }
    }

    > div:nth-child(2) {
      margin-top: 28%;
      width: 0; 
      height: 0;
      border-left: 2.2em solid white;
      border-top: 1.5em solid transparent;
      border-bottom: 1.5em solid transparent;
      transition:all linear .5s;
    }
  }

  @media (min-width:600px) and (max-width: 1024px) {
   
    > div:nth-child(1) {
      
    } 

    > p {
      
    }

    > div:nth-child(3) {
      
      
      

      &:hover {
        
      }

      &:hover {

        > div:nth-child(1) > a {
          
        }

        > div:nth-child(2) {
         
        } 
      }

      > div {
        

        > a:nth-child(1) {
         
        
        }
      }

      > div:nth-child(2) {
        margin-top: 28%;
        width: 0; 
        height: 0;
        border-left: 1.8em solid white;
        border-top: 1.3em solid transparent;
        border-bottom: 1.3em solid transparent;
        transition:all linear .5s;
      }
    }

  } 
      

  @media (max-width: 600px) {
    padding-bottom: 15%;
    

    > div:nth-child(1) {
      width: 40%;
      margin: 15% 0 10% 0;
    } 

    > p {
      width: 55%;
      padding-bottom: 10%;
      font-size: 5vw;
      text-align:center;
    }

    > div:nth-child(3) {
      display: flex;
      width:22%;
      background-color: transparent;
      cursor: pointer;
      transition:all linear 1s;
      
      

      &:hover {
        background: ${pinkAuricula};
       
      }

      &:hover {

        > div:nth-child(1) > a {
          
        }

        > div:nth-child(2) {
          border-left: 1.8em solid ${blackAuricula};
          transition: all 1s;
        } 
      }

      > div {
        
        
        > a:nth-child(1) {
          width: 90%;
          font-size: 8vw;
          line-height: 85%;
          margin-top: 5%;
          margin-left: 1%;
        
        }
      }

      > div:nth-child(2) {
        margin-top: 28%;
        width: 0; 
        height: 0;
        border-left: 1.8em solid white;
        border-top: 1em solid transparent;
        border-bottom: 1em solid transparent;
        transition:all linear .5s;
      }
    }
  }

`

export const ContacUs = styled.section `
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color:${pinkAuricula} ;
  /* ${props => props.changeColor === 'Mayor' ? 'blue' : pinkAuricula} */
  padding: 4% 0;

 

  > a:nth-child(1) {
    font-size: 3vw;
    font-family: 'BebasNeue';
    text-decoration: none;
    color: ${blackAuricula};
  }

  > a:nth-child(2) {
    font-size: 1.5vw;
    font-family: 'NotoSansRegular';
    text-decoration: none;
    color: ${blackAuricula};
  }

  @media (min-width:600px) and (max-width: 1024px) {

    > p:nth-child(1) {
      font-size:4vw;
    }

    > a:nth-child(2) {
      font-size: 2vw;
    }
  }

  @media (max-width: 600px) {
    padding:10%;

  

    > a:nth-child(1) {
      font-size: 8vw;
    }

    > a:nth-child(2) {
      font-size: 4.5vw;
      font-family: 'NotoSansRegular';
      text-decoration: none;
      color: ${blackAuricula};
    }
  }
`